// execute JS code
// can be used in conjunction with fetch to run code like $.getScript
const domEval = code => {
  const script = document.createElement('script')
  script.text = code
  document.head.appendChild(script).parentNode.removeChild(script)
}

export { domEval }
